import script from "./StatisticButton.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticButton.vue?vue&type=script&setup=true&lang=js"

import "./StatisticButton.vue?vue&type=style&index=0&id=74dca6eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74dca6eb"]])

export default __exports__